import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center font-display uppercase text-xs sm:text-sm tracking-wider px-7 py-3.5 transition-all duration-150 ease-out select-none";

const variants = {
  red: "bg-labred text-offwhite hover:bg-labyellow hover:text-charcoal",
  ghostWhite:
    "bg-transparent text-offwhite border border-offwhite hover:bg-offwhite hover:text-charcoal",
  ghostYellow:
    "bg-transparent text-labyellow border border-labyellow hover:bg-labyellow hover:text-charcoal",
};

export const LabButton = ({
  children,
  variant = "red",
  to,
  href,
  className = "",
  testId,
  ...rest
}) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testId} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testId} target="_blank" rel="noreferrer" {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button className={cls} data-testid={testId} {...rest}>
      {children}
    </button>
  );
};
